var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('on-demand',{attrs:{"registration-id":_vm.registrationId}})}
var staticRenderFns = []

export { render, staticRenderFns }